export { default } from "./LifestyleTabs";
export * from "./LifestyleTabs";
export * from "./LifestyleTabs.model";
